import { bodyShadowColor } from './BodyShadowStore';

export const updateBodyShadowColor = (value) => bodyShadowColor.update(oldValue => value);
